const depths = {
  menu: 9000,
  modal: 8000,
  deepdive: -9999,
};

export default depths;
